export default {
  slug: "junie",
  code: "JN",
  label: "Junie",
  hasLogo: false,
  krakenDir: "Junie",
  thumbnailColor: "#47E053",
  logoFamily: "jb",
};
